import React, { useEffect } from "react";
import Header from "../../components/home/Header";
import Footer from "../../components/home/Footer";
import BLogsContainer from "../../components/blogs/BLogsContainer";

const BlogsPage = () => {
  useEffect(() => {
    window.scroll("scroll", function () {
      window.scroll(0, 0);
    });
  }, []);
  return (
    <div>
      <Header />
      <BLogsContainer />
      <Footer />
    </div>
  );
};

export default BlogsPage;
